"use strict";

function eqHeight() {

  // Do this separately for each .js-eqheight instace on the page
  $(".js-eqheight").each(function (i, eqContainer) {
    // Create an object to store the keys and the heights
    var eqHeights = {};

    // Store key/value pairs of the keys and the tallest heights
    $(eqContainer).find("[data-eqheight]").each(function (i, eqItem) {
      eqItem.style.height = null;
      var eqCat = $(eqItem).data("eqheight");
      var eqItemHeight = eqItem.offsetHeight;

      if (!(eqCat in eqHeights) || eqItemHeight > eqHeights[eqCat]) {
        eqHeights[eqCat] = eqItemHeight;
      }
    });

    // Iterate over the object and explicitly set the heights on the elements
    $.each(eqHeights, function (eqKey, eqKeyHeight) {
      $(eqContainer).find("[data-eqheight=\"" + eqKey + "\"]").css("height", eqKeyHeight + "px");
    });
  });
}

$(document).ready(function () {

  // Touch device check
  if (!!('ontouchstart' in window) || !!('msmaxtouchpoints' in window.navigator)) {
    $("body").addClass("is-touch");
  }

  // Placeholder polyfill (because IE9)
  if (!('placeholder' in HTMLInputElement.prototype)) {
    $("[placeholder]").each(function () {
      var initial_value, input;
      input = $(this);
      initial_value = input.attr("placeholder");
      // Assign placeholder as the value attribute
      input.val(initial_value);
      // When focused
      input.focus(function () {
        if (input.val() === input.attr("placeholder")) {
          return input.val("");
        }
      });
      // When blurred
      return input.blur(function () {
        if (input.val() === "") {
          return input.val(initial_value);
        }
      });
    });
  }

  // Set equal heights on resize
  $(window).resize(eqHeight).trigger("resize");

  // Setup validation
  $(".js-validate").each(function (i, vForm) {
    $(vForm).validate({
      errorClass: "has-error",
      errorElement: "span",
      rules: {
        zipCode: { required: true, digits: true, minlength: 5 },
        yearsInBusiness: { required: true, digits: true },
        numberOfTechnicians: { required: true, digits: true },
        contactPhoneNumber: { required: true, phoneUS: true },
        contactEmailAddress: { required: true, email: true },
        contactFaxNumber: { required: true, phoneUS: true },
        servicesList: { required: true },
        isProvidingServices: { required: true },
        newsletterEmail: { required: true, email: true }
      },
      errorPlacement: function errorPlacement(error, element) {
        if (element.is(":radio") || element.is(":checkbox")) {
          error.appendTo(element.parents('.form-group'));
        } else {
          error.insertAfter(element);
        }
      }
    });
  });

  // Contact Form validate
  $(".js-contact-validate").each(function (i, vForm) {
    $(vForm).validate({
      errorClass: "has-error",
      errorElement: "span",
      rules: {
        contactEmail: { required: true, email: true }
      }
    });
  });

  // Mobile menu
  $(".js-nav-mobile-trigger").on("click", function (e) {
    e.preventDefault();
    $(e.currentTarget).toggleClass("is-open");
    $(".js-nav-mobile-content").toggleClass("is-open");
  });

  // Desktop subnav
  $(".js-subnav-has-children").hover(function (e) {
    if ($(window).width() > 992) {
      e.currentTarget.style.width = e.currentTarget.offsetWidth + "px";
      $(e.currentTarget.querySelector('ul')).slideDown();
      if ($(e.currentTarget).parents(".nav-row").length > 0) {
        $(".subnav-row").slideUp();
      }
    }
  }, function (e) {
    if ($(window).width() > 992) {
      if ($(e.currentTarget).parents(".nav-row").length > 0) {
        $(".subnav-row").slideDown();
      }
      $(e.currentTarget.querySelector('ul')).slideUp(function () {
        //e.currentTarget.style.width = null;
      });
    }
  });

  // Header scrolled
  $(window).on("scroll", function (e) {
    if ($(window).scrollTop() > 100) {
      $("body").addClass("is-scrolled");
    } else {
      $("body").removeClass("is-scrolled");
    }
  });

  // Show/Hide
  $(".js-showhide").on("click", function (e) {
    e.preventDefault();
    $(e.currentTarget).toggleClass("is-open");
    $(e.currentTarget).parents(".js-showhide-container").first().toggleClass("is-open").find(".js-showhide-target").first().slideToggle();
  });

  // Blog Filter
  $(".cinch-filter").find("li").on("click", function (e) {
    if (window.matchMedia("(max-width: 991px)").matches) {
      $(".cinch-filter").find("li").removeClass("cinch-filter-item--hidden");
      $(e.currentTarget).addClass("cinch-filter-item--hidden");
      $(".js-cinch-filter-current-mobile").html(e.currentTarget.innerHTML);
    }
  });

  // FAQ
  $(".js-faq-q").on("click", function (e) {
    e.preventDefault();
    $(e.currentTarget).toggleClass("is-open");
    $(e.currentTarget).next(".js-faq-a").slideToggle();
  });

  // Leadership Modals
  $(".js-leader-modal-open").on("click", function (e) {
    e.preventDefault();
    $(e.currentTarget).next(".js-leader-modal").addClass("is-open");
  });
  $(".js-leader-modal-close").on("click", function (e) {
    e.preventDefault();
    $(".js-leader-modal").removeClass("is-open");
  });

  // Carousels
  $(".js-carousel").slick({
    arrows: true,
    prevArrow: '<a href="#" class="slick-prev"></a>',
    nextArrow: '<a href="#" class="slick-next"></a>',
    //dots: true,
    //dotsClass: "cinch-carousel__dots",
    slidesToShow: 2,
    centerMode: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        centerMode: false
      }
    }]
  });

  $(".js-carousel-logos").slick({
    arrows: true,
    prevArrow: '<a href="#" class="slick-prev"></a>',
    nextArrow: '<a href="#" class="slick-next"></a>',
    slidesToShow: 5,
    centerMode: true,
    variableWidth: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }]
  });

  $(".js-carousel-careers").slick({
    arrows: true,
    prevArrow: '<a href="#" class="slick-prev"></a>',
    nextArrow: '<a href="#" class="slick-next"></a>',
    slidesToShow: 4,
    centerMode: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        centerMode: false
      }
    }]
  });
  $(".js-carousel-blog-images").slick({
    arrows: true,
    prevArrow: '<a href="#" class="slick-prev"></a>',
    nextArrow: '<a href="#" class="slick-next"></a>',
    slidesToShow: 3,
    centerMode: true,
    variableWidth: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  $(".js-carousel-blog-related").slick({
    arrows: true,
    prevArrow: '<a href="#" class="slick-prev"></a>',
    nextArrow: '<a href="#" class="slick-next"></a>',
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        centerMode: false
      }
    }]
  });

  // Media Block Carousel
  $(".js-carousel-media-block").slick({
    arrows: true,
    prevArrow: '<a href="#" class="slick-prev"></a>',
    nextArrow: '<a href="#" class="slick-next"></a>',
    //dots: true,
    //dotsClass: "cinch-carousel__dots",
    slidesToShow: 1,
    slidesToScroll: 1
  });

  // Enable Tooltips
  $('[data-toggle="tooltip"]').tooltip({
    container: "body"
  });

  // Comparison Chart Functions
  if ($(".js-compare-chart").length > 0) {
    // Show additional rows
    $(".js-compare-chart-addl").on("click", function (e) {
      e.preventDefault();
      $(".js-compare-chart-addl-rows").slideDown();
      $(e.currentTarget).fadeOut();
    });

    // On mobile, show rows for selected column
    $(".js-compare-chart-col").on("click", function (e) {
      e.preventDefault();
      var activeCol = $(e.currentTarget).data("showcol");
      //$(".js-compare-chart-body").data("activecol", activeCol);
      $(".js-compare-chart-body").attr("data-activecol", activeCol);
      $(".js-compare-chart-col").removeClass("is-active");
      $(e.currentTarget).addClass("is-active");
    });

    // Preserve Chart Nav Width on resize
    $(window).resize(function () {
      var chartNav = document.querySelector(".js-compare-chart-nav");
      var chartBody = document.querySelector(".js-compare-chart-body");
      chartNav.style.width = chartBody.offsetWidth + "px";
    }).trigger("resize");

    // Toggle Fixed Chart Nav
    $(window).on("scroll", function () {
      var chartElem = document.querySelector(".js-compare-chart");
      var chartNav = chartElem.querySelector(".js-compare-chart-nav");
      var chartBounds = chartElem.getBoundingClientRect();
      if (chartBounds.top <= 56) {
        $(chartElem).addClass("is-scrolled");

        if (chartBounds.bottom - chartNav.offsetHeight <= 56) {
          $(chartElem).addClass("is-scrolled-past");
        } else {
          $(chartElem).removeClass("is-scrolled-past");
        }
      } else {
        $(chartElem).removeClass("is-scrolled");
      }
    }).trigger("scroll");
  }

  // Transition Panel Functions
  if ($(".js-tpanel").length > 0) {
    // Set main container top padding
    var mc = $("#site-main");
    var mcTopPad = parseInt(mc.css("padding-top"));

    $("body").on("click", ".js-tpanel-showhide", function (e) {
      e.preventDefault();
      var padInterval = setInterval(function () {
        mc.css("padding-top", mcTopPad + $(".js-tpanel-content").innerHeight());
      }, 1);
      setTimeout(function () {
        clearInterval(padInterval);
        if ($(".js-tpanel-showhide").hasClass("is-open")) {
          mc.css("padding-top", mcTopPad + $(".js-tpanel-content").innerHeight());
        } else {
          console.log("open");
          mc.css("padding-top", mcTopPad);
        }
      }, 401);
    });

    // Trigger initial click
    setTimeout(function () {
      $(".js-tpanel-showhide").trigger("click");
    }, 500);
  }

  ///////////////////////////////
  // MY ACCOUNT
  ///////////////////////////////

  // Dashboard Nav - Mobile
  $("body").on("click", ".js-dash-nav-title", function (e) {
    $(this).toggleClass("is-open");
    $(".js-dash-nav-list").slideToggle();
  });

  // My Account Alerts Close
  $("body").on("click", ".js-myacc-alert-close", function (e) {
    e.preventDefault();
    $(this).parents(".js-myacc-alert").slideUp(function () {
      $(this).remove();
      if ($(".js-myacc-alert").length == 0) {
        $(".js-myacc-alerts").slideUp(function () {
          $(this).remove();
        });
      }
    });
  });
});